import React from 'react';
import styles from './SegmentVisualBuilder.module.css';

type EditorMode = 'visual' | 'json';

interface EditorModeToggleProps {
  mode: EditorMode;
  onChange: (mode: EditorMode) => void;
  disabled?: boolean;
}

export const EditorModeToggle: React.FC<EditorModeToggleProps> = ({
  mode,
  onChange,
  disabled = false,
}) => {
  return (
    <div
      className={styles.addConditionRow}
      style={{ border: 'none', padding: '0 0 0.75rem' }}
      role="tablist"
      aria-label="Editor mode">
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'visual'}
        aria-controls="segment-editor-panel"
        onClick={() => onChange('visual')}
        disabled={disabled}
        className={mode === 'visual' ? styles.addConditionBtn : undefined}
        style={mode === 'visual' ? { borderStyle: 'solid', borderColor: '#d1d5db' } : undefined}>
        Visual
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={mode === 'json'}
        aria-controls="segment-editor-panel"
        onClick={() => onChange('json')}
        disabled={disabled}
        className={mode === 'json' ? styles.addConditionBtn : undefined}
        style={mode === 'json' ? { borderStyle: 'solid', borderColor: '#d1d5db' } : undefined}>
        JSON
      </button>
    </div>
  );
};
